import { NotAuthenticatedError, NotAuthorizedError } from '@/lib/errors';

import { UserInfo, AccessContentPayload } from './types';

export const canAccess = (
  user: UserInfo,
  content: AccessContentPayload,
): boolean => {
  if (content?.free_access) {
    return true;
  }

  if (!user.isAuthenticated) {
    throw new NotAuthenticatedError('Not authenticated');
  }

  if (content?.allowed_roles?.length) {
    const hasRole = user.roles?.some(r => content.allowed_roles!.includes(r));
    if (!hasRole) {
      throw new NotAuthorizedError('Not authorized');
    }
  }

  const tierOrder = ['basic', 'premium', 'vip'];
  const userTierIndex = tierOrder.indexOf(user.subscriptionTier ?? '');
  const requiredTierIndex = tierOrder.indexOf(
    content?.subscription_tier ?? 'basic',
  );

  if (userTierIndex === -1 || userTierIndex < requiredTierIndex) {
    throw new NotAuthorizedError('Not authorized');
  }

  return true;
};
